module.exports = __webpack_public_path__ + "static/media/Bicocca - DK Gold_White.9655c47b.jpg";